import React from "react";
import * as styles from "./OneColumn.module.less";
import {ContentElementRenderer} from "../../../components/ContentElementRenderer";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

export function OneColumn({column, hasLightBackground, withGallery}) {
    return (
        <div className={gcs(styles.oneColumn, "oneColumn")}>
            <ContentElementRenderer
                items={column}
                hasLightBackground={hasLightBackground}
                additionalContext={{column: 1}}
                withGallery={withGallery}
            />
        </div>
    );
}
